module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic.97bec988.woff";